export enum SortByTypeEnum {
    DATE,
    STRING,
    NUMBER,
}
